var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.333 5.33398H18.6663C11.3025 5.33398 5.33301 11.3035 5.33301 18.6673V45.334C5.33301 52.6978 11.3025 58.6673 18.6663 58.6673H45.333C52.6968 58.6673 58.6663 52.6978 58.6663 45.334V18.6673C58.6663 11.3035 52.6968 5.33398 45.333 5.33398Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6662 30.3208C42.9953 32.5401 42.6162 34.8067 41.5829 36.7982C40.5496 38.7896 38.9146 40.4046 36.9105 41.4133C34.9065 42.422 32.6354 42.7731 30.4203 42.4166C28.2052 42.0602 26.1589 41.0144 24.5724 39.4279C22.986 37.8414 21.9402 35.7951 21.5837 33.58C21.2273 31.3649 21.5784 29.0939 22.5871 27.0898C23.5958 25.0857 25.2107 23.4508 27.2022 22.4174C29.1936 21.3841 31.4602 21.005 33.6795 21.3341C35.9433 21.6698 38.0391 22.7247 39.6574 24.343C41.2756 25.9612 42.3305 28.057 42.6662 30.3208Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.667 17.334H46.6937",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3aeb004989495c224be2444776c1594d.svg";
export { ForwardRef as ReactComponent };